import { useState } from "react";
import { EnlargeDialog } from "./EnlargeDialog";
import { StyledListImage } from "./styled";

interface ListImageProps {
  src: string;
  title?: string;
}

export const ListImage = ({ src, title = "" }: ListImageProps) => {
  const [isEnlarged, setIsEnlarged] = useState(false);

  return (
    <>
      <StyledListImage
        src={src}
        variant="square"
        onClick={() => setIsEnlarged(true)}
      />
      <EnlargeDialog
        imageSrc={src}
        title={title}
        isOpened={isEnlarged}
        onClose={() => setIsEnlarged(false)}
      />
    </>
  );
};
